import React, { useContext, useEffect, useState } from 'react'
import HeaderCarousal from '../HeaderCarousal';
import './SipDetailV2.scss'
import { Link, useParams } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackwardIcon from '@mui/icons-material/ArrowBackIos';
import ShareIcon from '@mui/icons-material/Share';
import { UserLoginContext } from '../../../contexts/LoggedInUserContext';
import SubcribedCausePage from '../SubcribedCausePage/SubcribedCausePage';
import NotSubcribedCausePage from '../NotSubcribedCausePage/NotSubcribedCausePage';
import { appCondition, fetchSubscriptionAmount, fetchSubscriptionCurrency, getABName, getCookie, getCurrencySymbol, getPledgeAmt, handleKettoLinks, handlePledgeMoreLink, makeOnDemandSubs, sipParamUrl } from '../../../services/helperFunctions';
import { getDonation, getSubscription, sendEvents } from '../../../redux/actions/Home';
import AvatarImage from "../../public/images/sip-select/avatar_group.png";

export const SIP_LABEL = {
    education: "Education",
    animals: "Animals",
    women_girls: "Women",
    food_hunger: "Food & Hunger",
    medical: "Medical",
    widow: "Widows",
    elderly: "Elderly",
    acid_victims: "Acid Victims"
};

export const SIP_STATUS = {
    ACTIVE: "ACTIVE",
    PAUSED: "PAUSED",
    CANCELLED: "CANCELLED",
    LAPSED: "LAPSED",
    NEW: "NEW"
}

const SipDetailV2 = () => {
    const { cause_name } = useParams();
    const { userData, multiArray, latestOrder, count, setCount, summary, setSummary } = useContext(UserLoginContext);
    const firstAmount = fetchSubscriptionAmount(latestOrder?.ondemandSubscription, userData?.latest_subscription?.currency);
    const currency = fetchSubscriptionCurrency(latestOrder, userData);

    const amount = localStorage.getItem('sipAmount');
    const newAmount = currency && getPledgeAmt(currency.toUpperCase(), parseInt(amount));

    const isAppUser = !!getCookie('platform');

    //State
    const [cause, setCause] = useState(null);
    const [causeDetail, setCauseDetail] = useState(null);
    const [sipStatus, setSipStatus] = useState("");
    const [isMobile, setIsMobile] = useState(false);

    //for open child component dialog 
    const [openPledgeMoreDialog, setOpenPledgeMoreDialog] = useState(null);

    //Effects
    useEffect(() => {
        if (cause_name) {
            setCause(cause_name);
            setCauseDetail(getCauseData(cause_name));
            window.scrollTo(0, 0);
        }
    }, [cause_name, multiArray, latestOrder]);

    useEffect(() => {
        setIsMobile(window.innerWidth < 768 ? true : false);
    }, [window])

    useEffect(() => {
      if (cause_name){
        sendEvents('pageView', cause_name, cause_name);
      } 
    }, [cause_name])

    //Methods
    const getCauseData = (cause_name) => {
        const data = (multiArray && cause_name && multiArray.find((item) => item.campaign_cause == cause_name)) ?? null;
        if (data) {
            setSipStatus(checkSipSubscribed(data));
            getDonation(data?.currency, summary, setSummary)
            getSubscription(count, setCount, cause_name)
        }
        return data;
    }

    const checkSipSubscribed = (causeDetail) => {
        if (causeDetail && causeDetail.label) return causeDetail.label;
        return "";
    };

    const handleSubscribeSIP = () => {
        let multiCauses = [cause];
        const sipParams = multiCauses.map((value) => `sip_cause=${value}`).join('&');
        const newSipParam = sipParamUrl(multiCauses, firstAmount);
        const multiAmount = firstAmount;
        const isABName = getABName();

        if(latestOrder?.isOnDemandSubscription){
            makeOnDemandSubs(userData.id, multiCauses, firstAmount, currency.toLowerCase(), latestOrder?.ondemandSubscription?.id, sipParams)
        }   else if (!isAppUser) {
            window.open(
              handleKettoLinks(
                `new/sip/payment-standalone?amt=${multiAmount}&currency=${currency}&sip_cause=${newSipParam}${isABName}&ref_or=retention`,
              ),
            );
        }   else if (getCookie('platform') !== 'ios' && appCondition('1.0.8')) {
            window.open(handleKettoLinks(`new/sip/payment-standalone?currency=${currency}&amt=${multiAmount}&sip_cause=${newSipParam}${isABName}&ref_or=retention`));
        }    else {
            window.open(handleKettoLinks(`new/login?em=${userData.email}&to=new/sip/payment-standalone&currency=${currency}&amt=${multiAmount}&sip_cause=${newSipParam}${isABName}&ref_or=retention`));
        }
    }

    const normalizedCurrency = (currency || 'INR').trim().toUpperCase();
    const PitchAmount = normalizedCurrency === 'INR' ? 100 : 10;

    return (
        <>
            {cause && <div className='wrap'>
                <div className='content'>
                    <div className="breadcrumb-wrapper">
                        {isMobile && <div className="left">
                            <Link to="/sipselect">
                                <ArrowBackwardIcon className='mfs-20' />
                            </Link>
                            <span>{`${causeDetail?.sip_cause?.info_2} SIP`}</span>
                        </div>}
                        {!isMobile && <div className="left">
                            <Link to="/sipselect" className='non-active-link'>
                                My SIP's
                            </Link>
                            <span className='arrow-wrapper'>
                                <ArrowForwardIosIcon />
                            </span>
                            <span className='active-link'>{`${causeDetail?.sip_cause?.info_2} SIP`}</span>
                        </div>}
                        <div className="right">
                            <Link to="/referral" className='share-wrapper'>
                                <ShareIcon />
                            </Link>
                        </div>
                    </div>
                    <div className={`sections ${sipStatus !== SIP_STATUS.ACTIVE ? "reduce-padding" : ""}`}>
                        <div className='left-section'>
                            <HeaderCarousal campaign_cause={cause} summary={summary} sipStatus={sipStatus} latestOrder={latestOrder} count={count} />

                            {sipStatus === SIP_STATUS.ACTIVE && <div className='cta-btn-wrapper'>
                                {!isMobile && <div className={`cta-btn`} onClick={()=>openPledgeMoreDialog && openPledgeMoreDialog('create_more_impact')} >{`Create more impact`}<ArrowForwardIcon className='mfs-16' />
                                </div>}
                                {isMobile && <div className={`cta-btn`} onClick={()=>openPledgeMoreDialog && openPledgeMoreDialog('donate_more_impact')}>{`Donate more`}<ArrowForwardIcon className='mfs-16' />
                                </div>}
                                {isMobile && <div className="pitch-section">
                                    <div className="avatar-group">
                                        <img src={AvatarImage} alt="Person 1" className="avatar" />
                                    </div>
                                    <div className="impact-content">
                                        for another <strong>{getCurrencySymbol(currency)}{PitchAmount}/mo</strong> for a year, you are<br />
                                        projected to impact more than <strong>24</strong> lives in a year
                                    </div>
                                </div>}
                            </div>}

                            {sipStatus === SIP_STATUS.NEW && <div className='cta-btn-wrapper'>
                                <div className={`cta-btn`} onClick={handleSubscribeSIP} >{`Start ${SIP_LABEL[cause]} SIP`}<ArrowForwardIcon className='mfs-16' /></div>
                            </div>}

                        </div>
                        <div className='right-section'>
                            {sipStatus !== SIP_STATUS.NEW ? (
                                <SubcribedCausePage setOpenPledgeMoreDialog={setOpenPledgeMoreDialog} cause={cause} causeDetail={causeDetail} sipStatus={sipStatus} latestOrder={latestOrder} />
                            ) : (
                                <NotSubcribedCausePage cause={cause} />
                            )}
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default SipDetailV2;
